import { useNavigate } from "react-router-dom"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { showAlert } from "../../../reducer/alertSlice"

/**
 * 로그인 인증 여부 수행
 * @param children 인증을 수행할 페이지 컴포넌트. <AuthCheck></AuthCheck> 로 묶어서 사용한다. 
 */
const AuthCheck = ({ children }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated)

    useEffect(() => {
        // 로그인 안 됐으면 로그인 페이지로 이동
        if (!isAuthenticated) {
            console.log("@AuthCheck - Auth Expired")
            dispatch(
                showAlert({
                    msg: "로그인 후 이용해주세요.",
                    func: () => {
                        navigate("/", { replace: true })
                    }
                })
            )
        }
    }, [isAuthenticated, dispatch, navigate])

    if (!isAuthenticated) {
        return null
    }
    // 로그인 돼 있으면 자식 컴포넌트 렌더링
    return children
}

export default AuthCheck